export let hres92uColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'dteyear',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'year'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '80',
    style: 'min-width: 300px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES92UC1',
    labelIndex: '140',
    style: 'min-width: 200px;'
  }]
  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres92u.js